import PropTypes from "prop-types";
import React, { useState } from "react";
import classNames from "classnames";
import TableContent from "../Table-Content";
import Heading from "../../elements/heading";
import BodyText from "../../elements/body-text";
import Checkbox from "../../elements/checkbox";
import IconLink from "../../elements/icon-link";
import PrimaryButton from "../../elements/primary-button";
import { getOverallSettingsClasses } from "../../utils/siteUtils";
import "./style.scss";
// import { cond } from "lodash";

export default function TableHighlight({ rendering, fields }) {
  const { headingBody, headingType, body, highlightCheckbox, downloadIconLink, loadMorePrimaryButton, tables } = fields,
    highlightChecked = highlightCheckbox?.fields.checked.value || false,
    [highlight, setHighlight] = useState(highlightChecked),
    [tablesToShow, setTablesToShow] = useState(2),
    tableHighlightClasses = classNames("table-highlight", getOverallSettingsClasses(fields));
  const download = () => {
    //download logic here
    console.log("download logic here");
  };
  return (
    <div className={tableHighlightClasses} datasourceid={rendering.dataSource}>
      <div className="grid">
        <div className="heading-body grid">
          {headingBody && (
            <Heading
              {...{
                type: headingType,
                html: headingBody,
                typographyClass: "type-h2",
                className: "title"
              }}
            />
          )}
          {body && (
            <BodyText
              {...{
                html: body.value,
                className: body.className || "body-text"
              }}
            />
          )}
        </div>

        {(highlightCheckbox?.fields || downloadIconLink?.fields) && (
          <div className="table-controls-top">
            {highlightCheckbox?.fields && (
              <div className="highlight">
                <Checkbox
                  {...{
                    label: highlightCheckbox.fields.label.value,
                    checked: highlightChecked,
                    onChange: value => setHighlight(value)
                  }}
                />
              </div>
            )}
            {downloadIconLink?.fields && (
              <div className="download">
                <IconLink
                  {...{
                    ...downloadIconLink.fields,
                    callback: () => download()
                  }}
                />
              </div>
            )}
          </div>
        )}
        {tables && (
          <div className="table-data-list">
            {tables.map((tableData, index) => {
              if (index >= tablesToShow) return null;
              return (
                <TableContent
                  key={`table-content${index}`}
                  {...{
                    ...{ ...tableData },
                    highlightRowDifferences: highlight,
                    firstColumnIsLeadColumn: false,
                    firstColumnIsHeadColumn: tableData.firstColumnIsHeadColumn ? tableData.firstColumnIsHeadColumn : false
                  }}
                />
              );
            })}
          </div>
        )}
        {loadMorePrimaryButton.fields && tables.length > 2 && (
          <div className="table-controls-bottom">
            <PrimaryButton
              {...{
                ...loadMorePrimaryButton.fields,
                buttonText: loadMorePrimaryButton.fields.buttonText.value,
                isDisabled: tablesToShow >= tables.length,
                callback: () => {
                  setTablesToShow(tablesToShow + 2);
                }
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
}

TableHighlight.propTypes = {
  fields: PropTypes.shape({
    headingBody: PropTypes.object,
    headingType: PropTypes.object,
    body: PropTypes.object,
    highlightCheckbox: PropTypes.object,
    downloadIconLink: PropTypes.object,
    loadMorePrimaryButton: PropTypes.object,
    tables: PropTypes.array,
    paddingAboveTop: PropTypes.object,
    paddingAboveBottom: PropTypes.object
  }),
  rendering: PropTypes.object
};

TableHighlight.defaultProps = {
  fields: {
    headingBody: {
      paddingAboveTop: {
        fields: {
          key: {
            value: "default"
          }
        }
      },
      paddingAboveBottom: {
        fields: {
          key: {
            value: "default"
          }
        }
      }
    }
  }
};
